import { Menu } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useSWR from 'swr';

export default function ElementsSideMenu({ ...props }) {
   const categories = useSWR(process.env.NEXT_PUBLIC_PREMAST_API_URL + `/categories?parent_id=3672`);

   const router = useRouter();
   const selectedKey = router.query.catSlug || 'all';

   return (
      <>
         <Menu
            selectedKeys={[selectedKey]}
            style={{
               backgroundColor: 'transparent',
               border: 'none',
            }}
            items={[
               {
                  key: 'all',
                  label: <Link href="/elements">All Elements</Link>,
               },
            ].concat(
               categories.data?.categories?.map((category, index) => ({
                  key: category.slug,
                  label: <Link href={`/elements/${category.slug}`}>{category.name}</Link>,
               }))
            )}
         />
      </>
   );
}
